import styled from 'styled-components';
import MuiAppBar from '@material-ui/core/AppBar';

const AppBar = styled(MuiAppBar)`
  && {
    top: ${props => props.theme.spacing(2)}px;
    display: flex;
    align-items: center;
    padding: ${props => `${props.theme.spacing(0.25)}px ${props.theme.spacing(0.5)}px`};
    margin-bottom: ${props => props.theme.spacing(2)}px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);
    background-color: ${props => props.theme.palette.background.paper};
    border-radius: ${props => props.theme.shape.borderRadius}px;
  }
`;

AppBar.defaultProps = {
  className: null,
  color: 'inherit',
  position: 'sticky',
  elevation: 0,
};

AppBar.propTypes = { ...AppBar.propTypes };

export default AppBar;
